import { suggestionList } from './suggestions';

// [ISO, name, dial code]
const PHONE_COUNTRIES: [string, string, string][] = [
  ['GB', 'United Kingdom', '44'], ['US', 'United States', '1'], ['IE', 'Ireland', '353'], ['FR', 'France', '33'], ['DE', 'Germany', '49'],
  ['ES', 'Spain', '34'], ['IT', 'Italy', '39'], ['PT', 'Portugal', '351'], ['NL', 'Netherlands', '31'], ['BE', 'Belgium', '32'],
  ['LU', 'Luxembourg', '352'], ['CH', 'Switzerland', '41'], ['AT', 'Austria', '43'], ['SE', 'Sweden', '46'], ['NO', 'Norway', '47'],
  ['DK', 'Denmark', '45'], ['FI', 'Finland', '358'], ['IS', 'Iceland', '354'], ['PL', 'Poland', '48'], ['CZ', 'Czech Republic', '420'],
  ['SK', 'Slovakia', '421'], ['HU', 'Hungary', '36'], ['RO', 'Romania', '40'], ['BG', 'Bulgaria', '359'], ['GR', 'Greece', '30'],
  ['CY', 'Cyprus', '357'], ['MT', 'Malta', '356'], ['HR', 'Croatia', '385'], ['SI', 'Slovenia', '386'], ['EE', 'Estonia', '372'],
  ['LV', 'Latvia', '371'], ['LT', 'Lithuania', '370'], ['UA', 'Ukraine', '380'], ['RU', 'Russia', '7'], ['BY', 'Belarus', '375'],
  ['TR', 'Turkey', '90'], ['CA', 'Canada', '1'], ['MX', 'Mexico', '52'], ['BR', 'Brazil', '55'], ['AR', 'Argentina', '54'],
  ['CN', 'China', '86'], ['JP', 'Japan', '81'], ['KR', 'South Korea', '82'], ['IN', 'India', '91'], ['PK', 'Pakistan', '92'],
  ['MY', 'Malaysia', '60'], ['SG', 'Singapore', '65'], ['ID', 'Indonesia', '62'], ['PH', 'Philippines', '63'],
  ['SA', 'Saudi Arabia', '966'], ['AE', 'United Arab Emirates', '971'], ['QA', 'Qatar', '974'], ['EG', 'Egypt', '20'],
  ['ZA', 'South Africa', '27'], ['NG', 'Nigeria', '234'], ['KE', 'Kenya', '254'],
  ['AU', 'Australia', '61'], ['NZ', 'New Zealand', '64'], ['HK', 'Hong Kong', '852'], ['TW', 'Taiwan', '886'],
];

function flagEmoji(code: string): string {
  return code.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

/**
 * Searchable dialling-code field beside a phone number. The chosen code is
 * kept on the number input's data-dial, and phoneFieldValue combines them.
 */
export function attachDialCode(displayInput: HTMLInputElement, numberInput: HTMLInputElement): void {
  numberInput.dataset.dial = numberInput.dataset.dial || '44';
  const list = suggestionList(displayInput, 220);
  const select = (c: [string, string, string]) => {
    numberInput.dataset.dial = c[2];
    displayInput.value = `${flagEmoji(c[0])} +${c[2]}`;
  };
  displayInput.addEventListener('focus', () => displayInput.select());
  displayInput.addEventListener('input', () => {
    const term = displayInput.value.trim().toLowerCase().replace(/^\+/, '');
    if (!term) { list.close(); return; }
    const matches = PHONE_COUNTRIES.filter(([, name, dial]) => name.toLowerCase().includes(term) || dial.startsWith(term)).slice(0, 20);
    list.show(matches, (c) => `${flagEmoji(c[0])} ${c[1]}`, (c) => `+${c[2]}`, select);
  });
  displayInput.addEventListener('blur', () => setTimeout(() => {
    list.close();
    const current = PHONE_COUNTRIES.find((c) => c[2] === numberInput.dataset.dial) || PHONE_COUNTRIES[0];
    displayInput.value = `${flagEmoji(current[0])} +${current[2]}`;
  }, 150));
}

/** "+44 7700…" from a phone input and its dialling code; '' when blank. */
export function phoneFieldValue(numberInput: HTMLInputElement): string {
  const number = (numberInput.value || '').trim();
  return number ? `+${numberInput.dataset.dial || '44'}${number}` : '';
}
